export const STATUS_NOT_REGISTERED = 'not_registered';
export const STATUS_REGISTERED = 'registered';
export const STATUS_FINISHED = 'finished';
export const STATUS_CANCELED = 'canceled';
export const STATUS_EXPIRED = 'expired';